import React, { useState } from 'react';
import { ChevronUp, ChevronDown, Clock, Info } from 'lucide-react';
interface PresenterNotesProps {
  notes: string[];
  timebox?: string;
  visibility: 'shown' | 'minimised' | 'hidden';
}
export function PresenterNotes({
  notes,
  timebox,
  visibility
}: PresenterNotesProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!notes || notes.length === 0 || visibility === 'hidden') return null;
  if (visibility === 'minimised') {
    return <div className="fixed bottom-6 right-6 z-40" data-id="element-73">
        <div className="w-3 h-3 rounded-full bg-sierra-blue shadow-md opacity-50" data-id="element-74" />
      </div>;
  }
  return <div className="fixed bottom-6 right-6 z-40 w-80" data-id="element-75">
      <div className="bg-white rounded-2xl sierra-shadow border border-gray-100 overflow-hidden transition-all duration-300" data-id="element-76">
        <button onClick={() => setIsExpanded(!isExpanded)} className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-77">
          <div className="flex items-center gap-2 text-sm font-medium text-sierra-dark" data-id="element-78">
            <Info className="w-4 h-4 text-sierra-blue" data-id="element-79" />
            Presenter Notes
          </div>
          <div className="flex items-center gap-3" data-id="element-80">
            {timebox && <span className="flex items-center gap-1 text-xs text-gray-500 font-normal bg-white px-2 py-0.5 rounded-full border border-gray-200" data-id="element-81">
                <Clock className="w-3 h-3" data-id="element-82" />
                {timebox}
              </span>}
            {isExpanded ? <ChevronDown className="w-4 h-4 text-gray-400" data-id="element-83" /> : <ChevronUp className="w-4 h-4 text-gray-400" data-id="element-84" />}
          </div>
        </button>

        {isExpanded && <div className="p-4 bg-white border-t border-gray-100" data-id="element-85">
            <ul className="space-y-2" data-id="element-86">
              {notes.map((note, idx) => <li key={idx} className="text-sm text-gray-600 flex items-start gap-2" data-id="element-87">
                  <span className="text-sierra-blue mt-1" data-id="element-88">•</span>
                  <span data-id="element-89">{note}</span>
                </li>)}
            </ul>
          </div>}
      </div>
    </div>;
}